import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCultureOfflineEvents } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { cultureVisitingsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';
import './index.scss';

const PdfCultureInstitutionsVisiting = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const cultureVisitings = useAppSelector(cultureVisitingsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().cultureOfflineVisitings });

  const hasData = cultureVisitings.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(cultureVisitings, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Посещение культурных учреждений" Icon={IconWidgetCultureOfflineEvents}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCultureInstitutionsVisiting;
